import { Api } from 'utils';

class PriceMeterService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/price-meter/get',params),
		update: async (params?: any) => Api.createResponse('admin/price-meter/update',params),
	}

}

export default PriceMeterService;